import { REDEEM_PROMO } from 'urls'
import tickMark from 'assets/images/okay.png'
import { useState } from 'react'
import 'styles/Redeem.scss'

const Redeem = ({ voucherCode, voucherSource, setStatus }) => {
    const [error, setError] = useState(null);
    const [voucherStatus, setVoucherStatus] = useState("Voucher code verified");
    async function redeemPromo() {
        const inputField = document.querySelector('#verified-screen .redeem-button');
        let promoCode = voucherCode.replace(/-/g, '');
        try {
            const data = await fetch(REDEEM_PROMO, {
                method: 'POST',
                body: JSON.stringify({
                    "promo_code": promoCode
                })
            })
            if (data.ok) {
                inputField.style.display = "none";
                setVoucherStatus("Voucher activated");
            } else {
                setStatus("REDEEMED")
            }
        } catch (e) {
            setError("Something went wrong! Please try again later.")
        }
  
    }

    return (
        <div id="verified-screen">
            <div className="tick">
                <img src={tickMark} alt="" />
            </div>
            <div className="subheading">
                {voucherStatus}
            </div>
            <div className="heading">
                {voucherCode}
            </div>
            <div className="subheading2">
                This voucher entitles the customer to a
            </div>
            <div className="subheading3">
                Free membership at Geetanjali salon
            </div>
            <div className="redeem-button" onClick={redeemPromo}>
                Redeem Voucher
            </div>
            <div className="back-to-home" onClick={() => setStatus("INIT")}>
                Back to Home
            </div>
            <div className="error-message">
            {
                error
                    ?
                    <div className="error-message">
                        {error}
                    </div>
                    :
                    null
            }
            </div>
        </div>
    );
}

export default Redeem;
